import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/index' },
  { path: '/index', name: 'index', component: Index, meta: { title: '茶信码企业信息' } },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  // 如果路由元信息中有title属性，则将其设置为页面标题
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router
